import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoZh: CultureInfo = {
  name: 'zh',
  displayName: 'Chinese',
  iso3LanguageCode: 'zho',
  iso2LanguageCode: 'zh',
  ietfLanguageTag: 'zh',
  parent: null
};
